module.exports = __webpack_public_path__ + "img/more-green-down.2833d914.svg";